import DefineDocumentArea from './define-document-area.view';

export default DefineDocumentArea;
